import { createMenuCmdField, EntityManagerConfig } from '../models/entity-config';
import { FattureRoutes } from '../modules/fatture/fatture.app-manager-routes';

export class FattureEMC extends EntityManagerConfig {
  override initFields(): void {
    this.cmdFields = [createMenuCmdField(FattureRoutes.FattFatturaList)];
  }
}
